import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { EmptyDataDisplyer, IDataDisplayer, IDataDisplayerColumnField, IDataDisplayerItem, IDataDisplayerPagination } from './DataDisplayer';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { ISearchParam } from '../../features/BaseApp';

interface IDataDisplayerState {
    displayers: Array<IDataDisplayer>
}

const initialState: IDataDisplayerState = {
    displayers: []
}

const dataDisplayerSlice = createSlice({
    name: "dataDisplyer",
    initialState,
    reducers: {
        addNewDispplayer: (state: IDataDisplayerState, action: PayloadAction<IDataDisplayer>) => {
            let displayers = state.displayers

            if (displayers.filter(displayers => displayers.name === action.payload.name).length === 0){
                state.displayers.push(action.payload)
            }

        },
        updateDisplayer: (state: IDataDisplayerState, action: PayloadAction<IDataDisplayer>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.name){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.name)
                        displayers[locationIndex] = action.payload

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerSelectedItems: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, selectedItems: Array<number> }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].selectedItems = action.payload.selectedItems

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerSearchParams: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, searchParamsList: ISearchParam[] }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].searchParamsList = action.payload.searchParamsList

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerItems: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, items: Array<IDataDisplayerItem> }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].items = action.payload.items

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerPagination: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, pagination: IDataDisplayerPagination }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].pagination = action.payload.pagination

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerAllItemsSelectedStatus: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, status: boolean }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].allItemsSelected = action.payload.status

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerLoadingStatus: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, status: boolean }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].loading = action.payload.status

                    }
                })
            }

            state.displayers = displayers

        },
        toggleDisplayerColumn: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, columnName: string }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const displayerIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        let hideColumnItems = displayers[displayerIndex].hideColumnItems 

                        if (hideColumnItems.includes(action.payload.columnName)){
                            hideColumnItems = hideColumnItems.filter(col => col !== action.payload.columnName)
                        }else{
                            hideColumnItems.push(action.payload.columnName)
                        }

                        displayers[displayerIndex].hideColumnItems = hideColumnItems

                    }
                })
            }

            state.displayers = displayers

        },
        deleteSelectedItem: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, id: number }>) => {
            const payload = action.payload

            let displayers = state.displayers

            displayers.map((displayer) => {
                if (displayer.name === payload.displayerName){
                    const displayerIndex = displayers.findIndex(displayer => displayer.name === payload.displayerName)

                    let selectedItems = displayers[displayerIndex].selectedItems
                    selectedItems = selectedItems.filter(item => item !== payload.id) 

                    displayers[displayerIndex].selectedItems = selectedItems

                }
            })

            state.displayers = displayers

        },
        updateColumnItems: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, columnItems: Array<IDataDisplayerColumnField> }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].columnItems = action.payload.columnItems

                    }
                })
            }

            state.displayers = displayers

        },
        updateDisplayerSearch: (state: IDataDisplayerState, action: PayloadAction<{ displayerName: string, search: string }>) => {
            let displayers = state.displayers
            
            if (displayers && displayers.length > 0){
                displayers.map((displayer) => {
                    if (displayer.name === action.payload.displayerName){

                        const locationIndex = displayers.findIndex(displayer => displayer.name === action.payload.displayerName)
                        displayers[locationIndex].search = action.payload.search

                    }
                })
            }

            state.displayers = displayers

        },
    }
})

/**
 * Return all displayer
 */
export const useReturnAllDisplayers = () => useSelector((state: RootState) => state.dataDisplayer.displayers)

/**
 * Retrun single displayer
 */
export const useReturnSingleDispplayer = (name: string) => {
    const dispplayers = useReturnAllDisplayers()

    let displayer: IDataDisplayer = EmptyDataDisplyer

    if (dispplayers.length > 0){
        dispplayers.map((singleDisplayer) => {
            if (singleDisplayer.name === name){
                displayer = singleDisplayer
            }
        })
    }

    return displayer

}

export const returnSingleDisplayer = (name: string, displayers: IDataDisplayer[]) => {

    let displayer: IDataDisplayer = EmptyDataDisplyer

    if (displayers.length > 0){
        displayers.map((singleDisplayer) => {
            if (singleDisplayer.name === name){
                displayer = singleDisplayer
            }
        })
    }

    return displayer

}

export const { addNewDispplayer, updateDisplayer, updateDisplayerSelectedItems, updateDisplayerItems, updateDisplayerAllItemsSelectedStatus, updateDisplayerPagination, updateDisplayerLoadingStatus, toggleDisplayerColumn, deleteSelectedItem, updateDisplayerSearch, updateColumnItems, updateDisplayerSearchParams } = dataDisplayerSlice.actions
export default dataDisplayerSlice.reducer